import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useState } from 'react';

const Video = ({ controls = false, src = '' }) => {
  const [play, setPlay] = useState(false);

  return (
    <>
      {!play && (
        <div className="text-white absolute inset-0 flex items-center justify-center">
          <PlayArrowIcon fontSize="large" />
        </div>
      )}
      <video
        onClick={() => {
          if (controls) setPlay((prev) => !prev);
        }}
        controls={controls}
        className="block h-full w-full rounded-lg object-cover object-center"
      >
        <source src={src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </>
  );
};

export default Video;
